import Combination from './combination.factory'
import CombinationListService from './combination-list.service'

const module = angular.module('ac.repositories.combination', [])

module.factory('Combination', Combination).service('CombinationListService', CombinationListService)

export default module.name
